// Compiler result to JSON file
    import { createComponent } from 'js/declViewModelService';
    import { registerDynImportEntry } from 'js/moduleLoader';
    import AwParseService from 'js/awParseService';
    import AwFilterService from 'js/awFilterService';
    import { getField } from 'js/utils';
    import { Fragment } from 'react';
    let filterSer = AwFilterService.instance;
    import AwPanel from 'viewmodel/AwPanelViewModel';
import AwList from 'viewmodel/AwListViewModel';
import AwImageCell from 'viewmodel/AwImageCellViewModel';
    

    

    /*
    ctx imports
    */
    
    const ctxImportObj = {  };
    

    /*
    dynamic import
    */
    registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/desUpdateLibraryService', () => import('js/desUpdateLibraryService'));
registerDynImportEntry('js/desCatalogEventBus', () => import('js/desCatalogEventBus'));;

    /*
    view model
    */
    const declViewModelJson = {
    "schemaVersion": "1.0.0",
    "imports": [],
    "data": {
        "limit": 50,
        "skip": 0,
        "selectedLibraries": null,
        "libraryList": {
            "displayName": "{{i18n.listLibrary}}",
            "type": "STRING",
            "isRequired": "true",
            "isEditable": "true",
            "dbValue": "",
            "dispValue": ""
        },
        "libraryToRemove": {
            "type": "STRING"
        },
        "nameOfLibraryToRemove": {
            "type": "STRING"
        }
    },
    "props": {
        "collaborationspaceid": {
            "type": "string"
        },
        "accsessionid": {
            "type": "string"
        }
    },
    "actions": {
        "fetchLibraryList": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": true,
                    "data": {
                        "additionalProperties": {
                            "collaborationSpaceId": "{{props.collaborationspaceid}}"
                        },
                        "query": "query listLibraries( $listLibrariesInput: ListLibrariesInput ) { listLibraries( listLibrariesInput: $listLibrariesInput) }",
                        "variables": {
                            "listLibrariesInput": {
                                "searchOptions": {
                                    "limit": "{{data.limit}}",
                                    "skip": "{{data.skip}}",
                                    "outputProperties": [
                                        "*"
                                    ]
                                }
                            }
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accSessionId": "{{props.accsessionid}}"
            },
            "outputData": {
                "libraryListViewTotalResults": "data.data.listLibraries.totalCount",
                "libraryListViewResponse": "data.data.listLibraries.libraryObjs",
                "thumbnailDownloadTicket": "data.data.listLibraries.thumbnailDownloadTicket",
                "skip": "data.data.listLibraries.skip",
                "totalFound": "data.data.listLibraries.totalFound"
            },
            "events": {
                "failure": [
                    {
                        "name": "listLibraries.failure",
                        "eventData": {
                            "eventName": "listLibrariesFailure",
                            "eventData": "{{libraryListViewResponse}}"
                        }
                    }
                ],
                "success": [
                    {
                        "name": "listLibraries.success",
                        "eventData": {
                            "eventName": "listLibrariesSuccess",
                            "eventData": "{{libraryListViewResponse}}"
                        }
                    },
                    {
                        "name": "thumbnailDownloadTicket.success",
                        "eventData": {
                            "eventName": "thumbnailDownloadTicketSuccess",
                            "eventData": "{{thumbnailDownloadTicket}}"
                        }
                    }
                ]
            },
            "actionMessages": {
                "failure": [
                    {
                        "message": "queryFailedMessage"
                    }
                ]
            },
            "deps": "js/accHttpService"
        },
        "performBatchActionOnLibrarySelection": {
            "actionType": "batchJob",
            "steps": [
                {
                    "action": "publishToACCEventBus",
                    "inputArgs": {
                        "eventName": "{{parameters.eventName}}",
                        "eventData": "{{parameters.eventData}}"
                    }
                },
                {
                    "action": "updateLocalVariable",
                    "inputArgs": {
                        "eventName": "{{parameters.eventName}}",
                        "eventData": "{{parameters.eventData}}"
                    }
                }
            ]
        },
        "updateLocalVariable": {
            "actionType": "JSFunction",
            "method": "updateVmoVariables",
            "inputData": {
                "data": "{{data}}",
                "keysToUpdate": {
                    "selectedLibraries": "{{parameters.eventData}}"
                }
            },
            "deps": "js/desUpdateLibraryService"
        },
        "reveal": {
            "actionType": "dataProvider",
            "method": "libraryListViewDataProvider"
        },
        "publishToACCEventBus": {
            "actionType": "JSFunction",
            "method": "publish",
            "inputData": {
                "eventId": "{{parameters.eventName}}",
                "eventData": "{{parameters.eventData}}"
            },
            "deps": "js/desCatalogEventBus"
        }
    },
    "dataProviders": {
        "libraryListViewDataProvider": {
            "action": "fetchLibraryList",
            "response": "{{data.libraryListViewResponse}}",
            "totalFound": "{{data.totalFound}}",
            "selectionModelMode": "single",
            "commandsAnchor": "des_LibraryOptionCommandAnchor",
            "position": "BOTTOM_RIGHT"
        }
    },
    "onEvent": [
        {
            "eventId": "libraryListViewDataProvider.selectionChangeEvent",
            "cacheEventData": true,
            "action": "performBatchActionOnLibrarySelection",
            "inputArgs": {
                "eventName": "desLibraryListSelectionChange",
                "eventData": "{{eventData.selectedObjects}}"
            }
        },
        {
            "eventId": "loadLibraryList",
            "action": "reveal",
            "cacheEventData": true
        }
    ],
    "conditions": {},
    "i18n": {
        "listLibrary": [
            "libraryMessages"
        ]
    },
    "_viewModelId": "DesLibraryList",
    "_uniqueViewModelId": "DesLibraryList",
    "ctx": {}
};

    /*
    <aw-panel class="des-image-styling-libraryList">
    <aw-list dataprovider="data.dataProviders.libraryListViewDataProvider">
        <aw-image-cell vmo="item"></aw-image-cell>
    </aw-list>
</aw-panel>

    */
    const renderFn =(props)=> {
        let subPanelContext = props.subPanelContext ;
        let { viewModel: { data, dataProviders, dispatch, conditions, selectionModels, editHandlers, chartProviders, ports  }, grids, ctx, actions, fields, messages, i18n, formProp, viewPath  } = props;
        data = {...data, dataProviders};
        if( subPanelContext && subPanelContext.fields ){
            fields = { ...fields, ...subPanelContext.fields };
        }
        let $index = null;
        return (
                <AwPanel  revealAction={actions.reveal}  className="des-image-styling-libraryList">
        <AwList dataprovider={dataProviders.libraryListViewDataProvider} showDropArea={null} dndHandler={props.viewModel.dndHandler}>{({item, index})=>{ return <>            <AwImageCell vmo={AwParseService.instance( "item" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports, item, index } )}>
            </AwImageCell></> } }
        </AwList>
    </AwPanel>
        )
    };


    /*
    define component
    */
    const Component = createComponent( declViewModelJson, renderFn, undefined, ctxImportObj );

    export default Component;